import { useEffect, useState } from "react";
import Tooltip from "../tooltip/Tooltip.jsx";

function Taskbar() {
  // const [apps, setApps] = useState([]);

  // useEffect(() => {
  //   let articles = document.querySelectorAll("article");
  //   setApps(Array.from(articles));
  // }, []);
  let array = [];
  if (window.taskbar) array = Object.values(window.taskbar);

  return (
    <nav id="taskbar">
      <ul>
        {array
          .filter((d) => d.status != "closed")
          .map((app, i) => (
            <li
              key={app.id + "-" + i}
              className="tooltip_hover"
              onClick={(e) => {
                if (window.updateTaskbar)
                  window.updateTaskbar(app.id.toLowerCase(), "", "taskbar");
              }}
              id={"icon-" + app.id.toLowerCase()}
            >
              <img src={"./apps-icons/" + app.id + ".svg"} />
              <Tooltip>{app.name}</Tooltip>
            </li>
          ))}
      </ul>
    </nav>
  );
}

export default Taskbar;
